import { ElementWithTooltipOrig } from 'src/components/common/vx/element-with-tooltip/ElementWithTooltipOrig';
import React from 'react';
import { Placement } from 'react-bootstrap/types';
import { ButtonProps, VXButton } from 'src/components/visionx/buttons/VXButton.tsx';

interface ActionBtnV2Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip?: string | React.ReactNode;
  extraClass?: string;
  iconClass: string;
  cy?: string;
  tc?: string;
  chartType?: string;
  disabled?: boolean;
  tooltipPlacement?: Placement | undefined;
  page?: number;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
}

const ActionBtnV2 = React.forwardRef<HTMLButtonElement, ActionBtnV2Props>(
  (
    {
      onClick,
      tooltip,
      extraClass = '',
      iconClass,
      cy,
      tc,
      chartType,
      disabled = false,
      tooltipPlacement = 'auto',
      page,
      variant = 'outline',
      size = 'sm',
      'aria-label': ariaLabel,
      ...props
    },
    ref,
  ) => {
    const resolvedAriaLabel =
      ariaLabel ?? (typeof tooltip === 'string' ? tooltip : tc || cy || 'action');

    const element = (
      <VXButton
        ref={ref}
        size={size}
        variant={variant}
        className={`${extraClass}`.trim()}
        data-cy={cy}
        data-tc={tc}
        data-chart_type={chartType}
        data-page={page}
        disabled={disabled}
        onClick={onClick}
        leftIcon={
          <i
            className={iconClass}
            aria-hidden="true"
          />
        }
        {...props}
        aria-label={resolvedAriaLabel}
      />
    );

    return tooltip ? (
      <ElementWithTooltipOrig
        placement={tooltipPlacement}
        element={element}
        tooltip={<span>{tooltip}</span>}
      />
    ) : (
      element
    );
  },
);

export default ActionBtnV2;
